import { call, put, takeEvery } from 'redux-saga/effects';
import { authActions } from 'store/auth/index';
import { authHelperActions } from 'store/auth/helper-actions';
import { AUTH_TOKEN } from 'data/constant';

function* hydrationFlow() {
	try {
		yield put(authActions.setAppRestoring(true));
		/*const token: string | null = yield call(
			[localStorage, 'getItem'],
			'token',
		);*/
		const token = AUTH_TOKEN;

		// if (token) {
		try {
			yield put(
				authActions.setLogin({
					address: '',
					token,
				}),
			);
		} catch (e) {
			// If getting user fails, clear the invalid token
			yield call([localStorage, 'removeItem'], 'token');
			// yield call([localStorage, 'removeItem'], 'appTId');
		}
		/*}*/
	} catch (e) {
		// console.error('Hydration error:', e);
	} finally {
		yield put(authActions.setAppReady(true));
		yield put(authActions.setAppRestoring(false));
	}
}

export function* authSaga() {
	yield takeEvery(authHelperActions.hydrate.type, hydrationFlow);
}
